// extracted by mini-css-extract-plugin
module.exports = {"container":"checkboxFancy_container__krvHb","checked":"checkboxFancy_checked__12w7S","check":"checkboxFancy_check__1tOiI"};